/** @module ProductSpec/SizeChart/ProductGroupSelectForm */
define([
	"dojo/_base/declare",
	"dijit/registry",
	"csi",
	"csi/_base/underscore",
	"csi/form/Widget",
	"csi/html",
	"csi/locale",
	"csi/widget/FormGroupSelection"
], function(declare, registry, csi, _, FormWidget, html, locale, FormGroupSelection) {

	/**
	 * This module is an inner widget for first row of Size Chart -> Product Group selection view
	 * UI Path: Home/Styles/Style->Style/Specification/SizeChart->SizeChart/Properties -> "Product Group" tooltip "Edit"
	 * UI Path: Home/Styles/Style->Style/Specification/SizeChart->SizeChart/Properties -> "Increment" tooltip "Edit"
	 * Outer view widget = ProductSpec/SizeChart/ProductGroupView.js
	 * Module = ProductSpec.xml
	 * View Id = "ProductGroup" xsi:type="Html"
	 * Template = "ProductSpec/SizeChart/ProductGroupView.html"
	 * ControllerClass = "ProductSpec/SizeChart/ProductGroupView"
	 */

	const CSS_CLASS_RADIO_GROUP_DISABLED = "csi-field-group-container-disabled";

	return declare(FormWidget, {

		/** @property {boolean} bSubView - true if widget used inside Increment or SizeRange view (rather then Product Group view)*/
		bSubView: false,

		/**
		 * @override
		 * Create Product Group selection widget
		 */
		onDrawGroup: function(defView, field, value, div, control, widgetParam) {
			const view = this;
			const tr = this.getFieldRow(field);
			html.clear(tr);
			const td = html.create("td", {colspan: 3}, tr)
			const node = this.getCache().getNode(widgetParam.value);
			const group = new FormGroupSelection({
				name: "picker",
				control: control,
				checkboxLabel: locale.resource("ProductGroupCheckboxLabel"),
				widgetUniqId: csi.getUniqueId(this.id),
				currentValueLabel: locale.resource("ProductGroupCurrent"),
				currentValue: node && node.$Name,
				currentAdditionalText: "",
				dropdownLabel: locale.resource("ProductGroupNew"),
				store: widgetParam.store,
				value: "",
				/**
				 * Check box on click event handler
				 * Enable/Disable Tolerances radio group depend on "Change Product Group" checked status
				 * @param {boolean} checked
				 */
				onChangeCheck: function(checked) {
					this.refreshRadioGroup(checked);
				},
				/**
				 * New Product Group drop down event handler
				 */
				onChangeValue: function(value) {
					const htmlView = this.getParent().viewParent;
					htmlView.set("newProductGroup", value);
					htmlView.refreshSaveBtn();
				},
				/**
				 * Enable/Disable Tolerances radio group depend on "Change Product Group" checked status
				 * @param {boolean} checked
				 */
				refreshRadioGroup: function(checked) {
					const htmlView = this.getParent().viewParent;
					// Hide unused radio group
					const jGroupTolerances = $(htmlView.domNode).find(".csi-radio-group-tolerances");
					if (checked) {
						jGroupTolerances.show();
					} else {
						jGroupTolerances.hide();
						// Uncheck checkboxes, reset selection
						_.each(jGroupTolerances.find(".dijitRadio"), function(el) {
							registry.byNode(el).set("checked", false);
						});
					}
					// Disable and clear drop down
					this.dropdownNode.set("value", "");
					this.dropdownNode.set("disabled", !checked);
					htmlView.changeProductGroup = checked;
					htmlView.refreshSaveBtn();
				}
			}).placeAt(td);

			// This view can be used as sub widget for several views
			const viewParent = this.viewParent;
			viewParent.productGroupForm = group;
			this.bSubView = !!viewParent.class.match("csi-view-SizeChartSubSizeRange-Increment") || !!this.viewParent.class.match("csi-view-SizeChartRevision-SizeRange");
			// If we are part of Increment view - preset MockSizeChart "Tolerances" enabled status
			if (this.bSubView) {
				group.defer(group.refreshRadioGroup);
			}
		},

	});
});